import { ButtonProps } from '@shared/components/Button';
import { grid } from '@shared/styles';
import { MenuButton } from './MenuButton';

/**
 * Menu.Button
 *
 * A pre-styled trigger button that toggles the menu. Shows an optional
 * down-arrow indicator and an active state while the menu is open. Use this
 * when you want a standard button trigger; use `Menu.Trigger` when you need to
 * wrap a custom element instead.
 */

export function MenuIconButton(props: Partial<ButtonProps> = {}) {
  const mergedProps = {
    variant: 'ghost',
    icon: 'dots',
    size: 'small',
    iconOnly: true,
    iconSize: grid(3),
    ...props,
  } as ButtonProps;
  return <MenuButton {...mergedProps} />;
}
